import { formatDuration } from '@common/utils/time'

import { useAudioFile } from '@/modules/chatting/hooks/useAudioFile'
import DeleteIcon from '@/modules/chatting/icons/delete.svg'
import SuccessIcon from '@/modules/chatting/icons/success.svg'
import { AudioPlayPauseButton } from '@/modules/chatting/ui/components/AudioPlayPauseButton'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'

interface Props {
  name: string
  duration: number
  onDelete: () => void
  uploadProgress: number
  isUploading: boolean
  fileUrl?: string
}

export const ChosenAudio = ({
  name,
  duration,
  onDelete,
  uploadProgress,
  isUploading,
  fileUrl,
}: Props) => {
  const { isPlaying, handlePause, handlePlay } = useAudioFile(fileUrl)

  return (
    <div className="rounded-md border border-border-secondary px-3 py-2">
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-2 text-title">
          <AudioPlayPauseButton
            isPlaying={isPlaying}
            onPause={handlePause}
            onPlay={handlePlay}
          />
          <div className="text-left font-medium">
            <div className="text-base leading-6">{name}</div>
            <div className="text-xs leading-5 text-secondary-300">
              {formatDuration(duration)}
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <IconButton
            icon={DeleteIcon}
            onClick={onDelete}
            disabled={isUploading}
            tooltip="Delete"
            className="text-danger-default disabled:text-secondary-300 hover:text-danger-dark"
          />
        </div>
      </div>
      {(isUploading || !!uploadProgress) && (
        <div className="mt-[8px] flex items-center gap-2">
          <progress
            className="flex-1"
            value={uploadProgress}
            max="100"
          />
          <span className="flex shrink-0 items-center gap-1 text-xs text-secondary-300">
            {uploadProgress}%{' '}
            {uploadProgress === 100 ? <SuccessIcon /> : <span>uploading</span>}
          </span>
        </div>
      )}
    </div>
  )
}
